import * as moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, convertStringToArray } from '../../../utils';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../restClient';
// feature flags utils
import {
  buildFeatureFlagsPayload, getLoggedInUserId, isSuperAdmin,
  resolveFeatureFlags, toOverrideMap
} from '../../../featureFlags';
import { FEATURE_FLAGS_TAXONOMY, USER_FEATURE_FLAGS_URL } from '../../../featureFlags/flags';
import FeatureFlagsSection from './FeatureFlagsSection';
// children
import { ActionBar, CompositeList, CompositeListItem, ItemHeading, ListRightContentSection } from '../../common/CompositeList/compositeList';
import Modal, { ModalFooter, ModalHeader } from '../../common/Modal';
import AddGroupSearchBox from '../AdminPanel/AddGroupSearchBox/';
// actionCreator
import { setDarkTitleBarContent } from '../../layouts/actions/actionCreator';
import { createGroup, setAdminTabIndex } from '../actions/actionCreator';
import { blockUi, unBlockUi } from '../../../actions/actionCreator';
// common components
import SimpleDropdown from '../../common/SimpleDropdown';
// styles
import './UserDetail.css';

const validate = (name, email, countryValue) => {
  return {
    name: name.length === 0,
    email: email.length === 0
  };
}

class UserDetail extends Component {

  state = {
    roleType: this.props.user.role.name,
    glsApproverValue: this.props.user.glsApprover,
    // productManager: this.props.user.productManager,
    name: this.props.user.name,
    email: this.props.user.email,
    phone: this.props.user.phone,
    countryValue: this.props.user.country !== undefined ? this.props.user.country.value : '',
    countryName: this.props.user.country !== undefined ? this.props.user.country.name : '',
    statusValue: this.props.user.userStatus !== undefined ? this.props.user.userStatus.value : '',
    statusName: this.props.user.userStatus !== undefined ? this.props.user.userStatus.name : '',
    lastModifiedBy: this.props.user.lastModifiedBy || this.props.loggedInUser,
    groupListData: [],
    roleListData: [],
    countryData: [],
    statusData: [],
    featureFlagDefinitions: [],
    featureFlagValues: {},
    initialFeatureFlagValues: {},
    showDialog: false,
    duplicteError: false,
    texoId: this.props.user.role.value,
    touched: {
      name: false,
      email: false,
      phone: false,
      countryValue: false
    }
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  componentDidMount() {
    this.props.setDarkTitleBarTitle(this.props.user.name);
  }

  getDisplayDate(date) {
    return moment(date).format("DD MMM YY");
  }
  handleBlur = field => evt => {
    this.setState({
      touched: { ...this.state.touched, [field]: true }
    });
  };

  componentWillMount() {

    aemHostClient("/aemData/formData/json_user-detail")
      .then(({ data }) => {
        this.setState({ pageJson: data.par });
      });

    aemHostClient("/aemData/formData/json_dark-title-bar")
      .then(({ data }) => {
        this.setState({ darkTitleBarJson: data.par });
        document.title = `${Translations(data.par.static_text_darkTitleBar.hsbcProfile, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
      });

    eapiClient('/usergroup/user/' + this.props.user.id)
      .then(({ data }) => {
        this.setState({
          groupListData: data.responseData
        })
      });

    taxonomyHostClient("/taxonomies/roles")
      .then(({ data, status }) => {
        this.setState({
          roleListData: data.responseData.classificationNodes.slice(1)
        })
      })

    taxonomyHostClient("/taxonomies/user-status")
      .then(({ data, status }) => {
        this.setState({
          statusData: data.responseData.classificationNodes
        })
      })

    taxonomyHostClient("/taxonomies/party/countries")
      .then(({ data }) => {
        this.setState({
          countryData: data.responseData.countryTaxonomy.classificationNodes
        })
      })

      .catch((error) => { });

    Promise.all([
      taxonomyHostClient(FEATURE_FLAGS_TAXONOMY),
      eapiClient(USER_FEATURE_FLAGS_URL.replace(':userId', this.props.user.id))
    ])
      .then(([taxonomyResponse, flagsResponse]) => {
        const definitions = (taxonomyResponse.data.responseData.classificationNodes || [])
          .filter(def => def.active === true);
        const overrides = toOverrideMap(
          flagsResponse.data.responseData && flagsResponse.data.responseData.featureFlags
        );
        const values = resolveFeatureFlags(definitions, overrides);
        this.setState({
          featureFlagDefinitions: definitions,
          featureFlagValues: values,
          initialFeatureFlagValues: values
        });
      })
      .catch(() => {
        this.setState({
          featureFlagDefinitions: [],
          featureFlagValues: {},
          initialFeatureFlagValues: {}
        });
      });
  }

  getSelectedGroup = (selectedGroup) => {
    if (!this.state.groupListData.find(item => selectedGroup.id === item.id)) {
      this.setState({ groupListData: this.state.groupListData.concat([selectedGroup]) });
    }
  }

  setRole = (e) => {
    let roleValue = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
    let texonomiId = e.target.value;
    this.setState({
      roleType: roleValue,
      texoId: texonomiId
    })
  }

  setCountry = (e) => {
    let name = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
    let value = e.target.value;
    this.setState({
      countryName: name,
      countryValue: value
    }, () => { })
  }

  setStatus = (e) => {
    let name = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
    let value = e.target.value;
    this.setState({
      statusName: name,
      statusValue: value
    }, () => { })
  }

  setGlsApproverVal = (e) => {
    this.setState({
      glsApproverValue: e.target.value
    })
  }

  setFeatureFlagValue = (flagId, enabled) => {
    this.setState(prevState => ({
      featureFlagValues: { ...prevState.featureFlagValues, [flagId]: enabled }
    }));
  }

  // setIsproductManagerVal = (e) => {
  //   this.setState({
  //     productManager: e.target.value
  //   })
  // }

  setInputvalue = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  submit = () => {
    this.setState({
      showDialog: true
    })
  }

  _onCancel = () => {
    this.setState({
      showDialog: false
    })
  }

  _onOk = () => {
    let payload = new SaveAndReturnPayload();
    payload.setPayload(this.state, this.props, this.props.loggedInUser);
    var userId = this.props.user.id;

    const featureFlags = buildFeatureFlagsPayload(
      this.state.initialFeatureFlagValues,
      this.state.featureFlagValues,
      this.state.featureFlagDefinitions,
      this.props.isSuperAdmin,
      this.props.loggedInUserId
    );

    const requests = [
      eapiClient("/users/" + userId, {
        method: 'PUT',
        data: JSON.stringify(payload.data)
      })
    ];

    if (featureFlags.length > 0) {
      requests.push(
        eapiClient(USER_FEATURE_FLAGS_URL.replace(':userId', userId), {
          method: 'PUT',
          data: JSON.stringify({ userId: userId, featureFlags: featureFlags })
        })
      );
    }

    this.props.blockUi();
    Promise.all(requests)
      .then(([{ data }]) => {
        this.props.unBlockUi();
        if (data.responseData.emailExist) {
          this.setState({
            duplicteError: true
          })
          this._onCancel();
        } else {
          this.props.setAdminTabIndex(0);
          this.props.history.push('/admin-panel/')
        }
      })
      .catch(() => {
        this.props.unBlockUi();
        this._onCancel();
      });
  }

  deleteGroup = (item) => {
    var group = this.state.groupListData.filter(id => {
      return id.id !== item.id
    })

    this.setState({
      groupListData: group
    })
  }

  render() {
    const errors = validate(this.state.name, this.state.email);
    const isDisabled = Object.keys(errors).some(x => errors[x]);

    const displayError = field => {
      const hasError = errors[field];
      const shouldShow = this.state.touched[field];

      return hasError ? shouldShow : false;
    };

    const { name, email, phone, glsApprover, caseOwned, lastLogin } = this.props.user
    return (
      (this.state.pageJson !== undefined) ?
        <div className="user-detail">
          <div className="user-detail--section">
            <h1>{this.translations(this.state.pageJson.text_data_profileData.title)}</h1>
            <dl className="user-detail--datalist">
              <dt className="user-detail--datalist__data_t">{this.translateWord(this.state.pageJson.text_data_profileData.fieldLabels)[0]}</dt>
              <dd className="user-detail--datalist__data_d">
                <div className="field-container">
                  <input
                    className=""
                    type="text"
                    name="name"
                    onBlur={this.handleBlur('name')}
                    value={this.state.name}
                    onChange={this.setInputvalue}
                  />
                  {
                    displayError("name") ? (
                      <div className="input-error-msg-section gdocs-error-align">
                        <span className="icon icon-circle-delete-solid"></span>
                        {'Please enter user name'}
                      </div>
                    ) : ''
                  }
                </div>
              </dd>

              <dt className="user-detail--datalist__data_t">{this.translateWord(this.state.pageJson.text_data_profileData.fieldLabels)[1]}</dt>
              <dd className="user-detail--datalist__data_d">
                <div className="field-container">
                  <input
                    className=""
                    type="text"
                    name="email"
                    onBlur={this.handleBlur('email')}
                    value={this.state.email}
                    onChange={this.setInputvalue}
                  />
                  {
                    displayError("email") ? (
                      <div className="input-error-msg-section gdocs-error-align">
                        <span className="icon icon-circle-delete-solid"></span>
                        {'Please enter user email'}
                      </div>
                    ) : ''
                  }
                  {
                    this.state.duplicteError ? (
                      <div className="input-error-msg-section gdocs-error-align">
                        <span className="icon icon-circle-delete-solid"></span>
                        {'Duplicate email id entered'}
                      </div>
                    ) : ''

                  }
                </div>
              </dd>

              <dt className="user-detail--datalist__data_t"> {this.translateWord(this.state.pageJson.text_data_profileData.fieldLabels)[2]} <span>({this.translations(this.state.pageJson.text_data_profileData.optionalText)})</span></dt>
              <dd className="user-detail--datalist__data_d">
                <div className="field-container">
                  <input
                    className=""
                    type="text"
                    name="phone"
                    value={this.state.phone}
                    onChange={this.setInputvalue}
                  />
                </div>
              </dd>
              <dt className="user-detail--datalist__data_t">{this.translateWord(this.state.pageJson.text_data_profileData.fieldLabels)[4]} <span>({this.translations(this.state.pageJson.text_data_profileData.optionalText)})</span></dt>
              <dd className="user-detail--datalist__data_d">
                <div className="user-detail--role-type-section">
                  <div className="field-container">
                    <SimpleDropdown
                      name="country"
                      value={this.state.countryValue}
                      defaultValue={'Please select'}
                      _onChange={this.setCountry}
                      options={this.state.countryData}
                      _onBlur={this.handleBlur('countryValue')}
                      optionTextSelector={"name"}
                      type="country"
                    />
                  </div>
                </div>
              </dd>
              <dt className="user-detail--datalist__data_t">{this.translateWord(this.state.pageJson.text_data_profileData.fieldLabels)[5]} <span>({this.translations(this.state.pageJson.text_data_profileData.optionalText)})</span></dt>
              <dd className="user-detail--datalist__data_d">
                <div className="user-detail--status-type-section">
                  <div className="field-container">
                    <SimpleDropdown
                      name="status"
                      value={this.state.statusValue}
                      defaultValue={'Please select'}
                      _onChange={this.setStatus}
                      options={this.state.statusData}
                      _onBlur={this.handleBlur('statusValue')}
                      optionTextSelector={"name"}
                      type="status"
                    />
                  </div>
                </div>
              </dd>
              <dt className="user-detail--datalist__data_t">{this.translateWord(this.state.pageJson.text_data_profileData.fieldLabels)[6]} <span>({this.translations(this.state.pageJson.text_data_profileData.optionalText)})</span></dt>
              <dd className="user-detail--datalist__data_d">
                <div className="user-detail--lastModifiedBy-type-section">
                  <div className="field-container">
                    <input
                      className=""
                      type="text"
                      name="lastmodifiedby"
                      onBlur={this.handleBlur('lastmodifiedby')}
                      value={this.state.lastModifiedBy}
                      disabled={true}
                    />
                  </div>
                </div>
              </dd>

            </dl>
          </div>
          <div className="user-detail--section">
            <h1>{this.translations(this.state.pageJson.text_data_activityData.title)}</h1>
            <dl className="user-detail--datalist">
              <dt className="user-detail--datalist__data_t">{this.translateWord(this.state.pageJson.text_data_activityData.fieldLabels)[0]}</dt>
              <dd className="user-detail--datalist__data_d">{this.getDisplayDate(lastLogin)}</dd>

              <dt className="user-detail--datalist__data_t">{this.translateWord(this.state.pageJson.text_data_activityData.fieldLabels)[1]}</dt>
              <dd className="user-detail--datalist__data_d">{caseOwned}</dd>
            </dl>
          </div>
          <div className="user-detail--section">
            <h1>{this.translations(this.state.pageJson.static_text_roleSettings.text)}</h1>
            <dl className="user-detail--datalist">
              <dt className="user-detail--datalist__data_t">{this.translations(this.state.pageJson.static_text_roleSettings.type)}</dt>
              <dd className="user-detail--datalist__data_d">
                <div className="user-detail--role-type-section">
                  <div className="user-detail--role-type-section-arrow">
                    <span aria-hidden="true" className="alignVerLine">|</span>
                    <span className="icon icon-chevron-down-small" style={{ position: 'absolute', top: '4px' }}></span>
                  </div>
                  <select
                    className="user-detail--role-type-section-drop-down"
                    value={this.state.roleType}
                    onChange={this.setRole}
                    title={this.state.roleType}
                  >
                    <option disabled>{this.state.roleType}</option>
                    {
                      this.state.roleListData.map((item, index) => (<option key={index} value={item.id} > {item.description} </option>))
                    }
                  </select>
                </div>
              </dd>
              {this.state.roleType !== 'Sales Manager' ? <span>
                <dt className="user-detail--datalist__data_t"> {this.translations(this.state.pageJson.radiobutton_glsApprover.title)}</dt>
                <dd className="user-detail--datalist__data_d">
                  <label><input type="radio" name="gls" value="yes" defaultChecked={glsApprover === true ? true : false} onChange={this.setGlsApproverVal} />{this.translateWord(this.state.pageJson.radiobutton_glsApprover.options)[0]}</label>
                  <label><input type="radio" name="gls" value="No" defaultChecked={glsApprover === false ? true : false} onChange={this.setGlsApproverVal} />{this.translateWord(this.state.pageJson.radiobutton_glsApprover.options)[1]}</label>
                </dd></span> : ''
              }
              {/* {
                this.state.roleType === 'Sales Manager' ? <span>
                  <dt className="user-detail--datalist__data_t"> {this.translations(this.state.pageJson.radiobutton_isProductManager.title)}</dt>
                  <dd className="user-detail--datalist__data_d">
                    <label><input type="radio" name="productManager" value={true} defaultChecked={productManager === true ? true : false} onChange={this.setIsproductManagerVal} />{this.translateWord(this.state.pageJson.radiobutton_isProductManager.options)[0]}</label>
                    <label><input type="radio" name="productManager" value={false} defaultChecked={productManager === false ? true : false} onChange={this.setIsproductManagerVal} />{this.translateWord(this.state.pageJson.radiobutton_isProductManager.options)[1]}</label>
                  </dd></span> : ''
              } */}
            </dl>
          </div>
          <FeatureFlagsSection
            heading="Feature access"
            definitions={this.state.featureFlagDefinitions}
            values={this.state.featureFlagValues}
            onChange={this.setFeatureFlagValue}
            superAdmin={this.props.isSuperAdmin}
            route={this.props.history.location.pathname}
          />
          <div className="user-detail--section user-detail--border-none">
            <h1>{this.translations(this.state.pageJson.static_text_introTitle.text)}</h1>
            <AddGroupSearchBox
              headerTitle={this.translations(this.state.pageJson.type_ahead_addGroup.title)}
              setSelectedOptions={this.getSelectedGroup}
              pageJson={this.state.pageJson}
              lang={this.props.lang}
            />
            <div className="user-detail--user-group-section">
              <CompositeList>
                {
                  this.state.groupListData.map((item, key) =>
                    <CompositeListItem key={key}>
                      <ListRightContentSection>
                        <ItemHeading showArrowIcon={false} _onClick={() => { }}><a>{item.group} {`(${item.memberCount} members)`} </a> </ItemHeading>
                      </ListRightContentSection>
                      <ActionBar _onClick={this.deleteGroup.bind(this, item)} />
                    </CompositeListItem>)
                }
              </CompositeList>
              {
                this.state.groupListData.length <= 0 && <h1>{this.translations(this.state.pageJson.static_text_roleSettings.noGroups)}</h1>
              }
            </div>
          </div>
          <div className="gdocs-clear-float"></div>
          <div className="user-detail--submit-section">
            <div className="form-buttons-wrapper">
              <button aria-label={this.translations(this.state.pageJson.button_addAccount.text)} className="gdocs-btn-submit" onClick={this.submit} disabled={isDisabled}>
                {this.translations(this.state.pageJson.button_done.text)}
              </button>
            </div>
          </div>
          <Modal
            show={this.state.showDialog}
            onClose={this._onCancel}
            bsClass={this.state.bsClass}>
            <ModalHeader title={this.translations(this.state.pageJson.modal_user_confirmation.modalTitle)}
            />
            <ModalFooter>
              <button
                className="gdocs-btn-default gdocs-mright-20 gdocs-mtop-20"
                onClick={this._onCancel}
              >
                {this.translations(this.state.pageJson.modal_user_confirmation.whiteBtn)}
              </button>
              <button
                className="gdocs-btn-primary"
                onClick={this._onOk}
              >
                {this.translations(this.state.pageJson.modal_user_confirmation.redBtn)}
              </button>
            </ModalFooter>
          </Modal>
        </div>
        : '')
  }
}

class SaveAndReturnPayload {
  constructor() {
    this.data = {};
  }
  setPayload({ glsApproverValue, groupListData, roleType, texoId, name, email, phone, countryName, countryValue, statusName, statusValue }, { user }, loggedInUser) {
    var groupData = groupListData.map(item => item.id)
    var glsApp = true;
    let userStatuslastUpdatedBy;
    // var productManagerData = productManager === 'true' ? 'yes' : 'No'
    if (glsApproverValue === 'Yes' || glsApproverValue === true) {
      glsApp = true
    } else if (glsApproverValue === 'No' || glsApproverValue === false) {
      glsApp = false
    }

    if (user.userStatus !== undefined) {
      if (statusValue !== user.userStatus.value) {
        userStatuslastUpdatedBy = loggedInUser;
      }
    } else {
      if (statusValue !== undefined || statusValue !== "") {
        userStatuslastUpdatedBy = loggedInUser;
      }
    }

    this.data = {
      glsApprover: roleType !== 'Sales Manager' ? glsApp : false,
      glsApproverData: roleType !== 'Sales Manager' ? glsApproverValue : 'No',
      // productManagerData: roleType === 'Sales Manager' ? productManagerData : 'No',
      // productManager: roleType === 'Sales Manager' ? (productManager === 'true' ? true : false) : false,
      groups: groupData,
      name: name,
      email: email,
      phone: phone,
      role: {
        name: roleType,
        value: texoId
      },
      country: {
        name: countryName,
        value: countryValue
      },
      status: user.status,
      userStatus: {
        name: statusName,
        value: statusValue
      },
      lastUpdatedBy: userStatuslastUpdatedBy
    };
  }
}

const mapStateToProps = state => {
  return {
    user: state.userAdmin,
    lang: state.lang,
    loggedInUser: state.auth.userDetails.emailAddress,
    loggedInUserId: getLoggedInUserId(state.auth.userDetails),
    isSuperAdmin: isSuperAdmin(state.auth.userDetails)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarTitle: pageTitle => {
      dispatch(setDarkTitleBarContent(pageTitle))
    },
    createGroup: group => {
      dispatch(createGroup(group))
    },
    setAdminTabIndex: index => {
      dispatch(setAdminTabIndex(index))
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);



// WEBPACK FOOTER //
// ./src/components/Admin/UserDetail/UserDetail.js